import React, { useState } from 'react';
import axios from 'axios';

const Register = () => {
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    password: ''
  });
  const { name, email, password } = userData;

  const onChange = e => setUserData({ ...userData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    const newUser = {
      name,
      email,
      password
    };
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const body = JSON.stringify(newUser);
      await axios.post('http://157.90.247.182:3001/api/users/register', body, config);
      console.log('User registered');
    } catch (error) {
      console.error(error.response.data);
    }
  };

  return (
    <div className="auth-form-container">
      <h1>Sign Up</h1>
      <form onSubmit={e => onSubmit(e)}>
        <input 
            type="text"
            placeholder="Name"
            name="name"
            value={name}
            onChange={e => onChange(e)}
            required 
        />
        <input 
            type="email"
            placeholder="Email Address"
            name="email"
            value={email}
            onChange={e => onChange(e)}
            required 
        />
        <input
            type="password"
            placeholder="Password"
            name="password"
            value={password}
            onChange={e => onChange(e)}
            minLength="6"
        />
        <input type="submit" value="Register" />
      </form>
      <div className="separator"></div>
    </div>
   );   
};

export default Register;
